import { atom, type AtomEffect } from 'recoil'
import {
  COMMENT_LIST_SORT_TYPE_LIST,
  COMMENT_LIST_SORT_TYPE_LOCAL_STORAGE_KEY,
  CommentListSortType,
} from '~/features/video_detail/components/tabs/comments/comment/CommentSortButton/constants'

const defaultValue: CommentListSortType = 'desc_like'

const getDefaultValue = () => {
  if (typeof window === 'undefined') {
    return defaultValue
  }
  const value = localStorage.getItem(
    COMMENT_LIST_SORT_TYPE_LOCAL_STORAGE_KEY,
  ) as CommentListSortType
  if (COMMENT_LIST_SORT_TYPE_LIST.includes(value)) {
    return value
  } else {
    return defaultValue
  }
}

const setValueEffect: AtomEffect<CommentListSortType> = ({ onSet }) => {
  onSet((newValue) => {
    if (typeof window === 'undefined') {
      return defaultValue
    }
    if (newValue !== null) {
      localStorage.setItem(COMMENT_LIST_SORT_TYPE_LOCAL_STORAGE_KEY, newValue)
    }
  })
}

export const CommentListSortTypeAtom = atom<CommentListSortType>({
  key: 'CommentListSortTypeAtom',
  default: getDefaultValue(),
  effects: [setValueEffect],
})
